<template>
    <div>
        <sweet-modal ref="modal" overlay-theme="dark">
            <div class="col-sm">
                <img :src="data.picture" class="rounded-circle img-circle-xl" alt="Cinque Terre" width="100" height="100"><br/>
                <h4 style="margin-top:10px;">{{data.firstname}}</h4>
                <div style="color: darkgray;">
                  <label v-if="data.phone">{{data.phone}}</label><br/>
                  <label v-if="data.tel">{{data.tel}}</label><br/>
                </div>
                <a :href="`https://admin-test.beneat.co/user/${data.id}`" type="button" class="btn btn-info" target="_blank" >
                    ดูข้อมูลโปรไฟล์
                </a>
            </div>
        </sweet-modal>
    </div>
    <!-- <div v-if="data">
    </div> -->
</template>

<script>
export default {
  name: 'PhoneCallModal',
  data () {
    return {
      data: ''
    }
  },
  methods: {
    openModal (data) {
      this.$refs.modal.open()
      this.data = data
    }
  }
}

</script>
